var _path, _g, _g2, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeatherRainyThunder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 142,
    viewBox: "0 0 145 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.4004 98.5757L97.9462 84.895C98.8523 84.2266 100 85.3332 99.3659 86.2633L90.2989 99.5525C90.0707 99.887 90.0667 100.326 90.2888 100.665L94.7165 107.415C95.007 107.857 94.9018 108.45 94.4765 108.766L78.0373 120.975C77.1318 121.648 75.9793 120.54 76.615 119.609L84.4167 108.174C84.6564 107.823 84.6476 107.358 84.3948 107.016L79.1899 99.9749C78.8614 99.5305 78.9557 98.9038 79.4004 98.5757Z",
    fill: "#FFDA57"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_139_396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0014 62.96C14.157 75.6742 23.6467 77.6899 24.7357 78H97.6976C98.8903 78 105.787 72.17 101.741 60.8169C97.6976 49.4705 85.7175 47.1447 82.4518 47.1447C83.1259 41.4595 81.0516 29.2207 67.3615 25.7476C53.6714 22.2744 47.5524 31.7429 46.2041 36.9113C43.7668 35.7743 37.5233 34.1824 32.0473 36.9113C26.5712 39.6402 25.7209 46.4212 25.9803 49.4705C21.9355 49.7289 13.877 52.7886 14.0014 62.96Z",
    fill: "#E6F2FD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_139_396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0014 72.96C46.157 85.6742 55.6467 87.6899 56.7357 88H129.698C130.89 88 137.787 82.17 133.741 70.8169C129.698 59.4705 117.718 57.1447 114.452 57.1447C115.126 51.4595 113.052 39.2207 99.3615 35.7476C85.6714 32.2744 79.5524 41.7429 78.2041 46.9113C75.7668 45.7743 69.5233 44.1824 64.0473 46.9113C58.5712 49.6402 57.7209 56.4212 57.9803 59.4705C53.9355 59.7289 45.877 62.7886 46.0014 72.96Z",
    fill: "#4A4A4A"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52 92L39 105",
    stroke: "#87E3FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67 92L46 113",
    stroke: "#87E3FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_139_396",
    x: 0,
    y: 19,
    width: 109,
    height: 73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_139_396"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_139_396",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_139_396",
    x: 32,
    y: 29,
    width: 109,
    height: 73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_139_396"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_139_396",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherRainyThunder);
export default __webpack_public_path__ + "static/media/weather-rainy-thunder.cbd86618f4e4f78013fccf8c816980b7.svg";
export { ForwardRef as ReactComponent };